module.exports = __webpack_public_path__ + "static/media/goblin_big_momma_head.2b6d2570.svg";